module.exports = __webpack_public_path__ + "img/video-placeholder-icon.56da2254.svg";